import { FC } from 'react';
import { Card, Typography } from '@mui/material';
import { AccentColor } from 'shared/theme/colors';
import { Col } from '../Col';
import { Row } from '../Row';

type AnalyticMetricFieldProps = {
  title: string;
  value: number | string | undefined;
  percentageChange?: number;
};

export const AnalyticMetricField: FC<AnalyticMetricFieldProps> = ({
  title,
  value = '-',
  percentageChange,
}) => {
  const formatPercentageChange = (percentageChange: number) => {
    let prefix = '';
    if (percentageChange > 0) {
      prefix = '+';
    }
    return `${prefix}${percentageChange}%`;
  };

  return (
    <Card sx={{ p: 5, height: 97 }}>
      <Col spacing={3}>
        <Typography
          variant="paragraphM"
          sx={{
            height: 25,
            alignItems: 'start',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {title}
        </Typography>
        <Row spacing={5}>
          <Typography variant="headerL">{value}</Typography>

          {percentageChange ? (
            <Typography
              variant="accentM"
              color={
                percentageChange > 0
                  ? AccentColor.Positive
                  : AccentColor.Negative
              }
              sx={{ mt: 7 }}
            >
              {formatPercentageChange(percentageChange)}
            </Typography>
          ) : null}
        </Row>
      </Col>
    </Card>
  );
};
